<template>
<div>
    <smallbutton toplabel="Record Admin Transaction" @click="startAdd()" v-if="showButton" class="button buttonpay"/>
    <linkbutton toplabel="Record Admin Transaction" @click="startAdd()" v-if="!showButton"/>
    <!--  MODAL -->
      <actionmodal ref="mymodal"> 
        <template v-slot:body>
            <form ref="balform">
                <label class="titlelabel">Record Transaction for {{AdminFundRequest.Name}}</label>
                <br/>
                
                <formentry  inputid="amount" label="Transaction Amount $"  v-model="AdminFundRequest.newAmount" inputtype="number"  :isrequired='trueParam'/>
                <formentry inputid="effectivedate" inputtype="date"  label="Effective Date"  v-model="AdminFundRequest.effectiveDate" :isrequired='trueParam'/>
                <formentry inputid="reason"  label="Reason"  v-model="AdminFundRequest.Reason" :isrequired='trueParam' />
                
                <div class="entry" v-if="showWalletTokenTypes">
                    <div class="entryTextDiv">
                        <label class="entryLabel" for="tokentypeselect">Payment Type</label>
                    </div>
                    <select name="" id="tokentypeselect" class='entrySelect' v-model="AdminFundRequest.walletTokenTypeId" required>
                        <option v-for="w in walletTokenTypeList" :key="w.id" :value="w.id" >
                            {{w.name}}
                        </option>
                    </select>
                </div>

                <div v-if="showPaymentPlan && account.paymentPlan!=null">
                    <applytopaymentdue :account="account" @checked="updateApplyToPayment" v-if="account.paymentPlan.AccountPaymentPlanID && !isSaved" />

                    <confirm ref="confirmDiffAmt" :isAlert="trueParam" :showButton="falseParam" :body="confirmDifferentAmount"  title="Payment Plan" @yes="ConfirmAddTransaction(true)" />
                </div>
                
                <smallbutton  @click="ConfirmAddTransaction()" toplabel="Save" :disabled="isSaved"/>
                <smallbutton  @click="$refs.mymodal.closeModal()" toplabel="Close"/>
                <div>
                    <label class="responsemessage">{{responseMessage}}</label>
                </div>
                
            </form>
            
            
        </template>
      </actionmodal>
    </div>
</template>

<script>
import datamethods from '../../datamethods.js'
import {mapFields} from 'vuex-map-fields'
import format from '../../format.js'
import smallbutton from '../controls/button.vue'
import linkbutton from '../controls/linkbutton.vue'
import actionmodal from './actionmodal.vue'
import formentry from '../controls/entry.vue'
import applytopaymentdue from '../actions/applytopaymentdue.vue'
import confirm from '../actions/confirm.vue'
export default {
    name:'addadmintrans',
    components:{
        smallbutton,
        actionmodal,
        formentry,
        linkbutton,
        applytopaymentdue,
        confirm
    },
    props:{
        account:{
            type:Object,
            required:true
        },
        showButton:{
            type:Boolean,
            default:false
        }
        
    },
    mixins:[datamethods,format],
    data(){
        return{
            isSaved:false,
            insave:false,
            responseMessage:'',
            pleaseWait:false,
            AdminFundRequest:{
                Name:'',
                fromAccount:0,
                toAccount:0,
                oldAmount:'',
                newAmount:'',
                Reason:'',
                effectiveDate:'',
            },
            walletTokenTypeList:[],
            trueParam:true,
            falseParam:false,
            updatePaymentItem:false,
            nextPaymentItem:null,
            confirmDifferentAmount:null
            
        }
    },
    computed:{
        ...mapFields([
            'disableAddFunds',
            'currentWallet',
            'loggedInUser'

        ]),
        showWalletTokenTypes(){
            if(window.SHOW_WALLETTOKENTYPE_ON_ADMINTRANS==undefined){return false}
            else{return window.SHOW_WALLETTOKENTYPE_ON_ADMINTRANS}
        },
        showPaymentPlan(){
            if(window.SHOW_PAYMENT_PLAN==undefined){return false}
            else{return window.SHOW_PAYMENT_PLAN}
        },
        nextPaymentIsLastPayment(){
            var lastIndex = this.account.paymentPlan.PaymentPlanItemList.length-1
            if(this.nextPaymentItem.AccountPaymentPlanItemID==this.account.paymentPlan.PaymentPlanItemList[lastIndex].AccountPaymentPlanItemID){
                return true
            }
            return false
        }
    },
    methods:{
        formatDateShort(dt){
            dt = this.$options.filters.formatDateShort(dt)
            return dt
        },
        updateApplyToPayment(ischecked,nxtPaymentItem){
            this.updatePaymentItem=ischecked
            this.nextPaymentItem=nxtPaymentItem
            console.log('apply to pmt ' + ischecked)
        },
        
        beforeAPI(){
            this.pleaseWait=true
            this.responseMessage=''
        },
        startAdd(){
            this.updatePaymentItem=false
            this.nextPaymentItem=null
            this.responseMessage=''
            this.isSaved=false
            var dt = this.$options.filters.formatDateForInputToday();
            this.AdminFundRequest={
                Name:'',
                fromAccount:0,
                toAccount:0,
                oldAmount:'',
                newAmount:'',
                Reason:'',
                effectiveDate:dt
               
            }   
            this.AdminFundRequest.oldAmount=0;
            this.AdminFundRequest.Name=this.account.Name;
            this.AdminFundRequest.fromAccount=this.account.ID;
            this.AdminFundRequest.employeeId=this.loggedInUser.user_personId;

            if(this.showWalletTokenTypes){this.getWalletTokenTypes()}

            this.$refs.mymodal.openModal()
        },
        async ConfirmAddTransaction(confirmed=false){
            if(this.insave){return}
            


            if(this.$refs.balform.checkValidity()){
                //if amt is different and we are applying pay plan, confirm first
                if(this.updatePaymentItem && !confirmed){
                    if(Number(this.AdminFundRequest.newAmount)<Number(this.nextPaymentItem.PaymentDueAmount)){
                        this.confirmDifferentAmount="Your payment of $" + this.AdminFundRequest.newAmount + " is LESS than the amount due of $" + this.nextPaymentItem.PaymentDueAmount + ". Do you want to make this payment?"
                        this.$refs.confirmDiffAmt.Show()
                        return
                    }else if(Number(this.AdminFundRequest.newAmount)>Number(this.nextPaymentItem.PaymentDueAmount)){
                        if(this.nextPaymentIsLastPayment){
                            this.responseMessage="Please enter an amount less than or equal to the remaining payment of $" + this.nextPaymentItem.PaymentDueAmount
                            return //don't allow
                        }else{
                            this.confirmDifferentAmount="Your payment of $" + this.AdminFundRequest.newAmount + " is MORE than the amount due of $" + this.nextPaymentItem.PaymentDueAmount + ". Do you want to make this payment?"
                            this.$refs.confirmDiffAmt.Show()
                            return
                        }
                        
                    }
                }
                this.insave=true
                this.beforeAPI();
                let req = {
                    adminfunds:this.AdminFundRequest,
                }
                var response = await this.callAPI(req,'addtransaction')

                if(response.Successful){
                    this.insave=false
                    
                    if(this.updatePaymentItem){
                        this.UpdatePaymentPlan(response.ResponseInteger)
                    }else{
                        //finish up
                        this.responseMessage="Add Transaction was successful"
                        this.isSaved=true
                        this.$emit('refresh')
                    }
                    
                }else{
                    this.insave=false
                    this.responseMessage = response.Message
                }
                this.pleaseWait=false;
            }
        },
        async UpdatePaymentPlan(atid){
           
                this.nextPaymentItem.PaymentAccountTransactionID=atid
                this.nextPaymentItem.PaymentAmount=this.AdminFundRequest.newAmount
                this.beforeAPI();
                let req = {
                    PaymentPlanItem:this.nextPaymentItem,
                    AccountID:this.account.ID
                }
                var response = await this.callAPI(req,'paypaymentplanitem')

                if(response.Successful){
               
                    //finish up
                    this.responseMessage="Add Transaction was successful. Applied to payment due on " + this.formatDateShort(this.nextPaymentItem.PaymentDueDate) + " for $" + this.nextPaymentItem.PaymentDueAmount.toFixed(2)
                    this.isSaved=true
                    this.$emit('refresh')
                   
                    
                }else{
                    this.insave=false
                    this.responseMessage = response.Message
                }
                this.pleaseWait=false;
            
        },
       async getWalletTokenTypes(){
            
            //setup request
            let req = {
             
            }
            //call api
            this.beforeAPI();
            var response = await this.callAPI(req,'wallettokentype_admin')
            //handle response
            if(response.Successful){
                this.walletTokenTypeList=response.list
            }else{
                this.responseMessage = response.Message
            }
            this.pleaseWait=false;
        },
        
       
        
    }
}
</script>

<style>

</style>





























